export const APP_VARIANT = Object.freeze({
  LOCAL: "local",
  INDIAN: "indian",
});

export const PLATFORMS = Object.freeze({
  IN: "IN",
  LK: "LK",
});

export const DIAL_CODES = Object.freeze({
  IN: "+91",
  LK: "+94",
});

export const APP_LANG = Object.freeze({
  EN: "en",
  SI: "si",
});

export const USER_ROLES = Object.freeze({
  OPERATOR: "OPERATOR",
  OPERATOR_L2: "OPERATOR_L2",
  USER: "USER",
});

export const TARGET_ENVIRONMENTS = Object.freeze({
  DEVELOP: "dev",
  PRODUCTION: "prod",
});

export const UTM_TAG_KEYS = ["utm_campaign", "utm_medium", "utm_source"];
export const OTHER_COUNTRY_CODE = "ZZ";
export const OTHER_PROFESSION_ID = 7;
export const HOUSE_WIFE_PROFESSION_ID = 18;
export const POST_SEARCH_CRITERIA = "post-search-criteria";
export const POST_SEARCH_PREFFERRED_SEARCH_ACTIVE_KEY =
  "post-search-prefferred-search-active";
export const CREATE_FLOW_INITIALIZED_KEY = "create-flow-initial-loaded";

export const PARENT_TYPE = Object.freeze({
  FATHER: "FATHER",
  MOTHER: "MOTHER",
});

export const SUPPORTED_CURRENCIES = Object.freeze({
  LKR: "LKR",
  INR: "INR",
  USD: "USD",
});

export const CURRENCY_META = Object.freeze([
  {
    code: "LKR",
    label: "Sri Lanka Rupee",
    shortName: "Rs",
    symbol: "Rs",
  },
  {
    code: "USD",
    label: "US Dollar",
    shortName: "USD",
    symbol: "$",
  },
  {
    code: "INR",
    label: "Indian Rupee",
    shortName: "INR",
    symbol: "₹",
  },
]);

export const COUNTRY_CURRENCY_META = Object.freeze([
  {
    code: "LK",
    label: "Sri Lanka",
    translationKey: "common.sriLanka",
    currency: "Rs",
    symbol: "LKR",
  },
  {
    code: "IN",
    label: "India",
    translationKey: "common.india",
    currency: "INR",
    symbol: "₹",
  },
  {
    code: "other",
    label: "Other Countries",
    translationKey: "common.otherCountry",
    currency: "USD",
    symbol: "$",
  },
]);

export const BANK_TRANSFER_STATUS = Object.freeze({
  NOT_REQUIRED: "NOT_REQUIRED",
  REDIRECT_NEW: "REDIRECT_NEW",
  REDIRECT_RENEW: "REDIRECT_RENEW",
});

export const FAQ_CATEGORIES = Object.freeze({
  ACCOUNT_CREATION: "ACCOUNT_CREATION",
  MATCHING_WITH_OTHER_ADS: "MATCHING_WITH_OTHER_ADS",
  SETTINGS: "SETTINGS",
});

export const TOP_AD_AMOUNT = Object.freeze({
  LKR: {
    amount: 1000,
    currency: "LKR",
  },
  USD: {
    amount: 6,
    currency: "USD",
  },
});

const Constants = {
  APP_VARIANT,
  META_DESCRIPTION:
    "Find your perfect match in Sri Lanka with Poruwa.lk | Sri Lankan Matrimony , the confidential matrimony site. Browse profiles securely for efficient Sri Lanka marriage proposals. Join us for modern love with traditional values.",
  ALLOWED_MONTHLY_MAGAZINE_APP_VARIANT: [APP_VARIANT.LOCAL],
  UTM_TAG_KEYS,
  APP_LANG,
  OTHER_COUNTRY_CODE: "ZZ",
  LANKA_COUNTRY_CODE: "LK",
  INDIAN_COUNTRY_CODE: "IN",
  JAPAN_COUNTRY_CODE: "JP",
  OTHER_PROFESSION_ID: 7,
  OTHER_PROFESSION_NAME: "Other",
  PARENT_TYPE: Object.freeze({
    FATHER: "FATHER",
    MOTHER: "MOTHER",
  }),
};

export const HttpCode = Object.freeze({
  OK: 200,
  BAD_REQUEST: 400,
});

export const META_DESCRIPTIONS = {
  [PLATFORMS.LK]:
    "Find your perfect match in Sri Lanka with Poruwa.lk | Sri Lankan Matrimony , the confidential matrimony site. Browse profiles securely for efficient Sri Lanka marriage proposals. Join us for modern love with traditional values.",
  [PLATFORMS.IN]:
    "Find your perfect match in Sri Lanka with Poruwa.lk | Sri Lankan Matrimony , the confidential matrimony site. Browse profiles securely for efficient Sri Lanka marriage proposals. Join us for modern love with traditional values.",
};

export const DEPRECATED_PREFFERRED_SEARCH_KEYS_LK = [
  "male",
  "female",
  "showHideInt",
  "ageRange",
  "heightRange",
  "checkedEthnicities",
  "checkedReligions",
  "checkedStatus",
  "checkedProf",
  "minEdu",
  "checkedFoodPref",
  "checkedAccountOwner",
  "checkedSmoking",
  "checkedDissabled",
  "checkedNicVerified",
  "checkedDrinking",
  "checkedResidentCountries",
  "checkedRegions",
];

export const CREATE_FLOW_STEP_META = Object.freeze([
  {
    label: "Personal",
    route: "complete-ad-personal",
    localeKey: "common.personal",
    index: 0,
    name: "PERSONAL_INFORMATIONS",
  },
  {
    label: "Private",
    route: "complete-ad-private",
    localeKey: "common.private",
    index: 2,
    name: "PRIVATE_INFORMATIONS",
  },
  {
    label: "Parents",
    route: "complete-ad-parent",
    localeKey: "common.parents",
    index: 1,
    name: "PARENTS_INFORMATIONS",
  },
  {
    label: "Review & Pay",
    route: "complete-ad-review",
    localeKey: "common.summery",
    index: 3,
    name: "REVIEW_AND_PAY",
  },
]);

export const OFFLINE_REQUEST_TYPES = Object.freeze({
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
  POST: "POST",
});

export const ROUTE_ACCESS_LEVEL = Object.freeze({
  PUBLIC_USER: "PUBLIC_USER",
  PROFILE_USER: "PROFILE_USER",
  TEMP_PROFILE_USER: "TEMP_PROFILE_USER",
});

export const ROUTE_ACCESS_STATUS = Object.freeze({
  ALLOWED: "ALLOWED",
  UNAUTHORIZED: "UNAUTHORIZED",
  PROHIBITED: "PROHIBITED",
  NOT_FOUND: "NOT_FOUND",
  INITIALIZING: "INITIALIZING",
});

export const ROUTE_PAGE_TEMPLATE = Object.freeze({
  NONE: "NONE",
  TEMPALTE_1: "TEMPALTE_1",
});

export const PROFILE_STATUS = {
  INCOMPLETE: "INCOMPLETE",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  IN_REVIEW: "IN_REVIEW",
  LIVE: "LIVE",
  EXPIRED: "EXPIRED",
  DISABLED: "DISABLED",
};

export const PAYMENT_OPTIONS = Object.freeze({
  ONLINE_PAYMENT: "online_payment",
  BANK_TRANSFER: "bank_transfer",
  OTHER: "other",
});

export const PAYMENT_TYPES = Object.freeze({
  IS_RECURRING: "isRecurring",
});

export const PAYMENT_IDS = Object.freeze({
  SELECTED_PACKAGE_ID: "SELECTED_PACKAGE_ID",
});

export const PAYMENT_METHOD_IDS = Object.freeze({
  LOCAL_CC: "local_cc",
  FOREIGN_CC: "foreign_cc",
  PAYPAL: "paypal",
  EZ_CASH: "ez_cash",
  FRIMI: "frimi",
  GENIE: "genie",
  M_CASH: "m_cash",
  VISHWA: "vishwa",
  AU_BANK: "au_bank",
  EU_BANK: "eu_bank",
  SL_BANK: "sl_bank",
  UK_BANK: "uk_bank",
  US_BANK: "us_bank",
});

export const SUBSCRIPTION_STATUSES = Object.freeze({
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  USER_CANCELLED: "USER_CANCELLED",
  SYSTEM_CANCELLED: "SYSTEM_CANCELLED",
  ADMIN_CANCELLED: "ADMIN_CANCELLED",
  GRACE_PERIOD: "GRACE_PERIOD",
  RENEWED: "RENEWED",
  RENEW_FAILED: "RENEW_FAILED",
});

export const PAYMENT_NETWORKS = Object.freeze({
  VISA: "VISA",
  MASTERCARD: "MASTERCARD",
  MASTER: "MASTER",
  AMEX: "AMEX",
});

export const PRICING_TIERS = Object.freeze({
  "1M": "1m",
  "2M": "2m",
  "3M": "3m",
  "2M_BASIC": "2m_basic",
  "3M_BASIC": "3m_basic",
  "3M_PRO": "3m_pro",
  "6M_VIP": "6m_vip",
});

export const PAYMENT_GATEWAYS = Object.freeze({
  STRIPE: "STRIPE",
  PAYHERE: "PAYHERE",
});

export const NOTIFICATION_KEYS = Object.freeze({
  OFF: "off",
  SMS: "sms",
  EMAIL: "email",
  EMAIL_SMS: "email_sms",
});

export default Constants;
